import http from "../httpService";

export const getApi = async ({ path, params, responseType }) => {
  return await http.GET(`${path}`, { params, responseType });
};

export const postApi = async ({ path, body, headers }) => {
  return await http.POST(`${path}`, body, { headers });
};

export const putApi = async ({ path, body }) => {
  return await http.PUT(`${path}`, body);
};

export const deleteApi = async ({ path, body }) => {
  return await http.DELETE(`${path}`, body);
};

export const patchApi = async ({ path, body }) => {
  return await http.PATCH(`${path}`, body);
};
